import type { WikiItemWarning } from "@esi/shared";
import { TriangleAlert } from "lucide-react";
import { useTranslation } from "react-i18next";
import { t as translate } from "../i18n/i18n.ts";

/** One OKF warning in words (D12); an unresolved link never says whether a hidden page exists. */
export function warningText(warning: WikiItemWarning): string {
  return translate(`wiki.okfChecks.warning.${warning.code}`, { target: warning.target ?? "" });
}

/**
 * An item's OKF warnings in review and in the publish confirmation: a quiet amber list under a
 * "Before publishing" label. They never block, so they never take the danger tone.
 */
export function ItemWarnings(props: {
  warnings: readonly WikiItemWarning[] | undefined;
  compact?: boolean;
}) {
  const { t } = useTranslation();
  if (!props.warnings?.length) {
    return null;
  }
  return (
    <section className="flex flex-col gap-1.5" aria-label={t("wiki.okfChecks.warnings")}>
      {props.compact ? null : (
        <h4 className="text-xs font-medium text-fg-muted">{t("wiki.okfChecks.warnings")}</h4>
      )}
      <ul className="flex flex-col gap-1 text-xs text-warning-fg">
        {props.warnings.map((warning) => (
          <li key={`${warning.code}:${warning.target ?? ""}`} className="flex items-start gap-1.5">
            <TriangleAlert aria-hidden className="mt-px size-3.5 shrink-0" strokeWidth={1.75} />
            <span className="min-w-0 break-words">{warningText(warning)}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
